__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = function(name, initScope) {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = function(msg) { return typeof console !== "undefined" && console.warn && console.warn(msg); };
	var uniqueName = "frontendaccounts";
	var register = function(name, version, factory, eager) {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = function(id) {
		var handleError = function(err) { warn("Initialization of sharing external failed: " + err); };
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = function(module) { return module && module.init && module.init(__webpack_require__.S[name], initScope); }
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult.catch(handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@sentry/vue", "8.47.0", function() { return function() { return __webpack_require__(1317); }; }, 1);
			register("@vuelidate/core", "2.0.3", function() { return __webpack_require__.e(204).then(function() { return function() { return __webpack_require__(6204); }; }); });
			register("@vuelidate/validators", "2.0.3", function() { return __webpack_require__.e(697).then(function() { return function() { return __webpack_require__(3697); }; }); });
			register("frontendcommon-3", "3.0.75-staging-3", function() { return function() { return __webpack_require__(9685); }; }, 1);
			register("pinia", "2.0.36", function() { return function() { return __webpack_require__(9876); }; }, 1);
			register("vue-i18n", "9.14.5", function() { return function() { return __webpack_require__(8552); }; }, 1);
			register("vue-router", "4.3.0", function() { return function() { return __webpack_require__(2201); }; }, 1);
			register("vue", "3.4.25", function() { return function() { return __webpack_require__(217); }; }, 1);
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(function() { return initPromises[name] = 1; });
};